import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import RelatedArticles from "components/Content/RelatedArticles";
import { ajax as $ajax } from "jquery";

const CONTENT_PATH = "/content/:id/related_articles.json";
const DRAFT_PATH = "/drafts/:id/related_articles.json";

export default function Loader({ articleId, draft }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const targetUrl = draft ? DRAFT_PATH : CONTENT_PATH;

  useEffect(() => {
    $ajax({
      url: targetUrl.replace(":id", articleId),
      success: data => setArticles(data),
      error: () => setError(true),
      complete: () => setLoading(false),
    });
  }, [articleId]);

  return (
    <RelatedArticles
      articles={articles}
      error={error}
      loading={loading}
    />
  );
}

Loader.defaultProps = {
  draft: false,
};

Loader.propTypes = {
  articleId: PropTypes.string.isRequired,
  draft: PropTypes.bool,
};
